import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AUTH_ROUTE_PATH } from '../models/auth-user.model';
import { AppModule, MODULE_ACTION, ModuleAction } from '../models/session.model';
import { AuthStateService } from '../services/auth-state.service';

export const modulePermissionGuard =
  (modules: AppModule | AppModule[], action: ModuleAction = MODULE_ACTION.READ): CanMatchFn =>
  () => {
    const auth = inject(AuthStateService);
    const router = inject(Router);
    const required = Array.isArray(modules) ? modules : [modules];

    return (
      required.some((module) => auth.hasModuleAccess(module, action)) ||
      router.createUrlTree([AUTH_ROUTE_PATH.NO_ACCESS])
    );
  };
